import script from "./SubmitEntryForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./SubmitEntryForm.vue?vue&type=script&setup=true&lang=ts"

import "./SubmitEntryForm.vue?vue&type=style&index=0&id=6e00fa55&scoped=true&lang=css"

import exportComponent from "E:\\Sites\\mk64\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e00fa55"]])

export default __exports__